"use client"

import { useRouter } from "next/navigation"
import { Button } from "./button"
import { ChevronLeft } from "lucide-react"

interface BackButtonProps {
  backLink?: string
}

export function BackButton({ backLink }: BackButtonProps) {
  const router = useRouter()

  const handleBack = () => {
    if (backLink) {
      router.push(backLink)
    } else {
      router.back()
    }
  }

  return (
    <Button
      onClick={handleBack}
      variant="outline"
      className="flex items-center justify-center rounded-full w-8 h-8 p-0"
    >
      <ChevronLeft className="w-4 h-4" />
    </Button>
  )
}
